import React from 'react';
import { translate } from '../../Services/translation';

const ImageRepositoryListItemGroupHeader = () => {
  return (
    <div className="grid grid-cols-5 items-center gap-4 border-b border-solid border-gray-100 pb-2">
      <h6 className="text-md">{translate('general.image')}</h6>
      <h6 className="col-span-2 text-md">{translate('general.name')}</h6>
      <h6 className="text-md">{translate('general.file-size')}</h6>
      <h6></h6>
    </div>
  );
};

export default ImageRepositoryListItemGroupHeader;
